import React, { useState } from "react";
import { updateRequest } from "../lib/requests";
import { REQUEST_SERVICES } from "../lib/requests";
import { Modal, toast, formatDate } from "./UI";

const STATUSES = ["Pending", "In Progress", "Completed", "Rejected"];

const STATUS_STYLE = {
  "Pending":     { background: "#E6F1FB", color: "#185FA5" },
  "In Progress": { background: "#FAEEDA", color: "#854F0B" },
  "Completed":   { background: "#E1F5EE", color: "#0F6E56" },
  "Rejected":    { background: "#FCEBEB", color: "#A32D2D" },
};

export default function ReviewRequestModal({ request, onClose, onSaved }) {
  const [status,     setStatus]     = useState(request.status);
  const [adminNotes, setAdminNotes] = useState(request.adminNotes || "");
  const [saving,     setSaving]     = useState(false);

  const save = async () => {
    setSaving(true);
    try {
      await updateRequest(request.id, status, adminNotes);
      toast("Request updated!");
      onSaved(); onClose();
    } catch (e) {
      toast(e.message, "error");
    } finally {
      setSaving(false);
    }
  };

  const serviceLabels = request.services?.map(id => {
    const svc = REQUEST_SERVICES.find(s => s.id === id);
    return svc ? `${svc.icon} ${svc.label}` : id;
  }) || [];

  return (
    <Modal title="Review request" onClose={onClose} maxWidth={500}>
      <div style={{ background: "var(--bg-soft)", borderRadius: "var(--radius)", padding: "12px 14px", marginBottom: 16 }}>
        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 8 }}>
          <span style={{ fontWeight: 600, fontSize: 14 }}>{request.customerName}</span>
          <span style={{ fontSize: 12, color: "var(--text-muted)" }}>{request.customerEmail}</span>
        </div>
        {request.packageId && (
          <div style={{ fontSize: 12, fontFamily: "monospace", color: "var(--text-muted)", marginBottom: 8 }}>
            Package: {request.packageId} · {request.packageDesc}
          </div>
        )}
        <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginBottom: 8 }}>
          {serviceLabels.map((s, i) => (
            <span key={i} style={{ background: "var(--green-light)", color: "var(--green-dark)", fontSize: 12, fontWeight: 600, padding: "3px 10px", borderRadius: 20 }}>{s}</span>
          ))}
        </div>
        {request.totalCost > 0 && (
          <div style={{ fontSize: 14, fontWeight: 700, color: "var(--green-dark)" }}>Total: ${request.totalCost}</div>
        )}
        {request.note && (
          <div style={{ fontSize: 13, marginTop: 8, color: "var(--text)", lineHeight: 1.6 }}>
            <span style={{ fontWeight: 600 }}>Note: </span>{request.note}
          </div>
        )}
        <div style={{ fontSize: 11, color: "var(--text-faint)", marginTop: 6 }}>Submitted {formatDate(request.createdAt)}</div>
      </div>

      <div className="form-row">
        <label>Status</label>
        <select value={status} onChange={e => setStatus(e.target.value)}>
          {STATUSES.map(s => <option key={s} value={s}>{s}</option>)}
        </select>
      </div>
      <div className="form-row">
        <label>Response to customer</label>
        <textarea rows={3} value={adminNotes} onChange={e => setAdminNotes(e.target.value)} placeholder="Your response will be visible to the customer..." />
      </div>
      <div className="modal-footer">
        <button className="btn btn-ghost" onClick={onClose}>Cancel</button>
        <button className="btn btn-primary" onClick={save} disabled={saving}>{saving ? "Saving..." : "Save"}</button>
      </div>
    </Modal>
  );
}
